"use client";

import Link from "next/link";
import type { ComponentProps } from "react";
import { localizePath } from "../lib/i18n/config";
import { useLocale } from "./LocaleProvider";

type Props = Omit<ComponentProps<typeof Link>, "href"> & { href: string };

export default function LocaleLink({ href, ...rest }: Props) {
  const locale = useLocale();
  return <Link href={localizePath(locale, href)} {...rest} />;
}
